export default __webpack_public_path__ + "static/media/(4).2a3c80ad.jpeg";